import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

class DropdownLink extends React.PureComponent {
  static propTypes = {
    to: PropTypes.string,
    target: PropTypes.string,
    onClick: PropTypes.func
  };

  static defaultProps = {
    to: "#",
    target: null
  };

  render() {
    return (
      <Link
        to={this.props.to}
        className="dropdown-item"
        target={this.props.target}
        onClick={this.props.onClick}
      >
        {this.props.children}
      </Link>
    );
  }
}

export default DropdownLink;
